import { STABLE_EMPTY_ARRAY } from '@feedyou/utils'
import { Option } from '../../../lib/options'
import { endpointHelpers } from '../../../features/serverBots/endpointHelpers'
import { useMemo } from 'react'
import { useFeature } from '../../../store/features'

export const useBotSelectOptions = (): Option[] | 'LOADING' => {
  const result = endpointHelpers.getBotsMetadata.useQuery()
  const displayTestBots = useFeature('LIST_TEST_BOTS')

  return useMemo(() => {
    if (result.isLoading) {
      return 'LOADING'
    }

    if (!result.data) {
      return STABLE_EMPTY_ARRAY
    }

    return result.data.metadata
      .filter(metadata => displayTestBots || metadata.environmentType === 'prod')
      .filter(metadata => !metadata.archivedAtTimestamp)
      .filter(metadata => !metadata.softDeletedAtTimestamp)
      .map(metadata => ({ value: metadata.id, label: metadata.name || metadata.id }))
  }, [result])
}
